module.exports = __webpack_public_path__ + "01_veryshort_gold.595896d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_veryshort_gold.png
// module id = 8eDL
// module chunks = 0